import { FC } from 'react'
import styled from 'styled-components'
import { BaseButton } from '../../buttons'
import CloseIcon from '@tuhi/components/assets/images/closeIcon.svg'

export const headerHeight = '3em'

const Header = styled.header`
    background-color: ${(p) => p.theme.colors.primaryGreen};
    padding-left: 1em;
    //color: ${(p) => p.theme.colors.darkGrey};
    // color: ${(p) => p.theme.colors.primaryGreen};
    line-height: ${headerHeight};
    font-weight: bold;
    display: flex;
    color: ${(p) => p.theme.colors.white};
    // border-bottom: ${(p) => `1px solid ${p.theme.colors.lightGrey}`};
`

const HeaderText = styled.span``

const CloseButton = styled(BaseButton)`
    height: 100%;
    aspect-ratio: 1;
    margin-left: auto;
    color: ${(p) => p.theme.colors.white};

    &:hover {
        background-color: ${(p) => p.theme.colors.primaryRed};
        color: ${(p) => p.theme.colors.white};
    }
`

interface Props {
    title: string
    onClose: () => void
}

export const SlideHeader: FC<Props> = ({ title, onClose }) => {
    return (
        <Header>
            <HeaderText>{title}</HeaderText>
            <CloseButton onClick={onClose}>
                <span
                    style={{
                        width: '32px',
                        height: '32px',
                        display: 'inline-block',
                    }}
                >
                    <CloseIcon />
                </span>
            </CloseButton>
        </Header>
    )
}
